import { lazy } from "react";

export const CHUNK_RELOAD_KEY = "tra_chunk_load_reload";

export function isChunkLoadError(err) {
  if (!err) return false;
  if (err.name === "ChunkLoadError") return true;
  const msg = String(err.message || err);
  return /Loading chunk [\w./-]+ failed/i.test(msg) || /ChunkLoadError/i.test(msg);
}

/**
 * On stale webpack chunk URLs (HMR / deploy), reload once per tab session.
 * @returns {boolean} true if a reload was scheduled
 */
export function tryReloadForChunkError(err) {
  if (!isChunkLoadError(err) || typeof window === "undefined") return false;
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    return false;
  }
  sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
  window.location.reload();
  return true;
}

/**
 * React.lazy wrapper that recovers from stale webpack chunk URLs.
 */
export function lazyWithChunkReload(factory) {
  return lazy(() =>
    factory().catch((err) => {
      if (tryReloadForChunkError(err)) {
        return new Promise(() => {});
      }
      throw err;
    })
  );
}
